import * as React from 'react';
import { GroupBuilder } from '../../Group/GroupBuilder';
import { Direction, sortByProperty } from '../../Helpers/SortHelper';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { JobVacancy } from '../../Model/JobVacancy';
import { StaticSettings } from '../../StaticSettings';
import { GroupComponent } from '../GroupComponent';
import { ListProps } from '../ListProps';
import { GroupHeader } from './GroupHeader';
import { GroupItem } from './GroupItem';

export class Groups extends React.Component<ListProps<JobVacancy>> {
    public render() {
        const filteredModels = this.props.filteredModels;
        const sortProperty = StaticSettings.ui.list.jobVacancySortBy;
        if (sortProperty !== undefined) {
            return this.renderGroups(sortByProperty(filteredModels, sortProperty, Direction.Desc));
        } else {
            return this.renderGroups(filteredModels);
        }
    }

    private renderGroups(filteredModels: JobVacancy[]) {
        const groups = (new GroupBuilder()).groupByIndustry<JobVacancy>(filteredModels);

        const selectedJobVacancies = this.props.selectedJobVacancies;
        const isSelected = (m: JobCenterModelInterface) => {
            return selectedJobVacancies.contains(m);
        };

        return <>
            {groups.map(
                group => <GroupComponent
                    key={group.key.referenceId}
                    group={group}
                    renderItem={m => <GroupItem model={m} selected={isSelected(m)}/>}
                    renderHeader={() => <GroupHeader/>}
                />
            )}
        </>;
    }
}
